import { Component, Input } from '@angular/core';
import { MEDDICScores } from '@vendasta/sales-opportunities';
import { computeProgress, computeScoreSum } from '../../meddic-scores/meddic-scores';

const MAX_MEDDIC_SCORE = 2;

@Component({
  selector: 'sales-ui-meddic-progress-bar',
  templateUrl: './meddic-progress-bar.component.html',
  styleUrls: ['./meddic-progress-bar.component.scss'],
  standalone: false,
})
export class MEDDICProgressBarComponent {
  colorClass: string;
  progress: number;
  categoriesMet: number;
  potentialScoreSum: number;

  @Input() loading: boolean;

  @Input() set scores(s: MEDDICScores) {
    this.progress = computeProgress(s) * 100;
    if (s) {
      this.colorClass = chooseColorClass(this.progress);
      this.categoriesMet = computeScoreSum(s);
      this.potentialScoreSum = Object.keys(s).length * MAX_MEDDIC_SCORE;
    }
  }
}

function chooseColorClass(progress: number): string {
  if (progress < 50) {
    return 'red';
  }
  if (progress < 100) {
    return 'yellow';
  }
  return 'green';
}
